<template>
	<div class="full">
		<vxe-table :data="tableData" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="ordercode" title="线上单号"></vxe-column>
			<vxe-column field="shopname" title="店铺名称"></vxe-column>
			<vxe-column field="amount" title="金额"></vxe-column>
			<vxe-column field="item_time" title="原业绩时间">
				<template #default="{ row }">
					<span>{{$Moment(row.item_time*1000).format('YYYY-MM-DD')}}</span>
				</template>
			</vxe-column>
			<vxe-column field="performance_time" title="现业绩时间">
				<template #default="{ row }">
					<span>{{$Moment(row.performance_time*1000).format('YYYY-MM-DD')}}</span>
				</template>
			</vxe-column>
			<vxe-column field="targetstaffid" title="现业绩归属人">
				<template #default="{ row }">
					<span>{{$systemMethods.getstaff(row.targetstaffid)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="mark" title="备注"></vxe-column>
		</vxe-table>
		<file-index type="download" :comapnyid="comapnyid" :row="currentrow" ref="contractfile" />
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import fileIndex from '@/components/forms/contract/audit/index.vue'
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				allAlign: null,
				tableData: [],
				currentrow: null,
				comapnyid: 0,
			}
		},
		watch: {
			row(e){
				if(!e){
					this.tableData = []
				}		
			}
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			isaudit({
				cellValue
			}) {
				return window.systemMethods.getEmunValue('enable', cellValue)
			},
			download(row) {
				this.currentrow = row
				this.comapnyid = this.row.comapnyid
				this.$refs.contractfile.modalShow = true
			},
			getdetail() {
				this.$api.clickfarm.list({
					id: this.row.id,
					son:'clickfarm_detail'
				}).then((res) => {
					this.tableData = res.list
				})
			}
		},
		components: {
			fileIndex
		}
	}
</script>